import React, { useState } from 'react';
import { FC } from 'react';
import { useParams, Link } from 'react-router';
import {
    getTenantForSuperAdmin,
    getTenantStorageUsagesForSuperAdmin,
} from '../../../APIs/tenants';
import { TenantModel, TenantStorageUsage } from '../../../models/TenantModel';
import { useAuth } from '../../../contexts/AuthContext';
import { NotFound } from '../../Errors';
import { Loading } from '../../atomic/effects';
import { columnDefiner, Table, TableRow } from '../../atomic/table';
import { comma } from '../../../utils/FormUtils';
import { ColumnDef } from '@tanstack/react-table';

type TenantStorageData = TenantStorageUsage & TableRow;
const definer = columnDefiner<TenantStorageData>();

const columns = [
    definer.accessor('date', {
        header: '日付',
        cell: (d) => {
            const { date } = d.row.original;

            return (
                <>
                    <div className="date">
                        <span>{date}</span>
                    </div>
                </>
            );
        },
    }),
    {
        header: '利用率',
        cell: (d) => {
            const { usage } = d.row.original;
            return <>{usage}%</>;
        },
    },
    {
        header: '利用量',
        cell: (d) => {
            const { sizeGB } = d.row.original;
            return <>{comma(sizeGB)}GB</>;
        },
    },
] satisfies ColumnDef<TenantStorageData, any>[];
type Prop = {};
export const TenantStorageUsages: FC<Prop> = () => {
    const { isSuperAdmin } = useAuth();
    const { tenantId } = useParams();
    const [tenant, setTenant] = useState<TenantModel>();
    const [tenantStorageUsages, setTenantStorageUsages] = useState<
        TenantStorageUsage[]
    >([]);

    React.useEffect(() => {
        if (isSuperAdmin() && tenantId) {
            getTenantForSuperAdmin(tenantId)
                .then((resp) => {
                    setTenant(resp.data);
                })
                .catch((err) => {
                    console.warn(err);
                });
        }
    }, []);

    React.useEffect(() => {
        if (tenantId) {
            getTenantStorageUsagesForSuperAdmin(tenantId, 30)
                .then((resp) => {
                    setTenantStorageUsages(resp.data);
                })
                .catch((err) => {
                    console.warn(err);
                });
        }
    }, [tenantId]);

    if (!isSuperAdmin) {
        return <NotFound />;
    }
    if (!tenant) {
        return <Loading />;
    }
    const options = {};
    return (
        <>
            <div className="app-main admin-tenant">
                <div className="header">
                    <h2 className="header-name">
                        ストレージ利用履歴({tenant.name})
                    </h2>
                </div>
                <ul className="tenant-status-list">
                    <li>
                        <b>ストレージ使用量:</b> {comma(tenant.size)} GB
                    </li>
                    <li>
                        <b>最大サイズ:</b> {comma(tenant.availableStorageSize)}{' '}
                        GB
                    </li>
                    <li>
                        <b>使用率:</b> {tenant.usage}%
                    </li>
                </ul>
                <div className="usages-table">
                    <Table
                        data={tenantStorageUsages}
                        columns={columns}
                        options={options}
                    />
                </div>
                <div>
                    <Link to={`/app/superadmin/tenants`}>テナント一覧</Link>
                </div>
            </div>
        </>
    );
};
